module.exports = ".login-form {\n    max-width: 300px;\n  }\n\n  .login-form-forgot {\n    float: right;\n  }\n\n  .login-form-button {\n    width: 100%;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main